import { Button } from 'gantri-components';
import { useAtomValue, useSetAtom } from 'jotai';
import { addDesignModalAtoms } from '../../../add-design-modal.atoms';
import { addDesignModalSteps } from '../../../add-design-modal.constants';

export const AddDesignModalSizeStepFooter = () => {
  const setStep = useSetAtom(addDesignModalAtoms.step);
  const sizeDetails = useAtomValue(addDesignModalAtoms.sizeDetails);

  const isDisabled = !sizeDetails?.name;

  return (
    <>
      <Button
        size="large"
        text="Back"
        variant="secondary"
        onClick={() => {
          setStep(addDesignModalSteps.subCategory);
        }}
      />
      <Button
        disabled={isDisabled}
        size="large"
        text="Next"
        onClick={() => {
          setStep(addDesignModalSteps.name);
        }}
      />
    </>
  );
};
